import React, { useState, useEffect } from "react";
import { styled } from "@material-ui/styles";
import { IStyledArguments } from "../../types/styled-arguments";
import StepInitial from "./StepInitial";
import { useQuery, useMutation } from "@apollo/client";
import { gql } from "@apollo/client";
import { injectIntl } from "react-intl";
import Button from "../button";
import { ActionLink } from "../atoms";
import messages from "./PageRegister.intl";
import UserAvatar from "../user-avatar";
import { UnauthenticatedLayout } from "../unauthenticated-layout-elements";
import { Box, useTheme, Theme } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import PersonAddIcon from "@material-ui/icons/PersonAdd";

export const SIGN_UP = gql`
  mutation SignUp(
    $name: String!
    $email: String!
    $surname: String!
    $password: String!
    $role: String!
    $workspace: String
    $invite: String
  ) {
    signUp(
      input: {
        name: $name
        email: $email
        surname: $surname
        password: $password
        role: $role
        workspace: $workspace
      }
      invite: $invite
    ) {
      name
      email
    }
  }
`;

export const PLAYER_QUERY = gql`
  query player($id: ID!) {
    player(id: $id) {
      name
      surname
    }
  }
`;

const SuccessCard = styled(Box)(({ theme }: IStyledArguments) => ({
  textAlign: "center",
  padding: theme.spacing(4),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
  },
}));

const SuccessIcon = styled(Box)(({ theme }: IStyledArguments) => ({
  width: "100px",
  height: "100px",
  borderRadius: "50%",
  background: theme.palette.success.main,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto 24px",
  boxShadow: "0 4px 16px rgba(16, 21, 26, 0.12)",
  "& svg": {
    fontSize: "60px",
    color: "white",
  },
}));

const SuccessMessage = styled("div")(({ theme }: IStyledArguments) => ({
  fontSize: "1.5rem",
  fontWeight: 700,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down("sm")]: {
    fontSize: "1.25rem",
  },
}));

const SuccessSubtext = styled("div")(({ theme }: IStyledArguments) => ({
  fontSize: "1rem",
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(3),
}));

const StyledActionLink = styled(ActionLink)(({ theme }: IStyledArguments) => ({
  textDecoration: "none",
  display: "inline-block",
  "& button": {
    minWidth: "200px",
    padding: theme.spacing(1.5, 4),
    fontSize: "1rem",
    fontWeight: 600,
    borderRadius: "12px",
    background: theme.palette.primary.main,
    transition: "all 0.3s ease",
    "&:hover": {
      background: theme.palette.primary.dark,
      transform: "translateY(-2px)",
      boxShadow: "0 8px 16px rgba(16, 21, 26, 0.16)",
    },
  },
}));

const LoadingContainer = styled(Box)(({ theme }: IStyledArguments) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "400px",
  gap: theme.spacing(2),
}));

const registrationMapping = (registrationCode: string) => {
  console.log("registrationCode");
  console.log(registrationCode);
  const registration = atob(registrationCode);
  const parts = registration.split(";");
  console.log(parts);
  const myObject: { [index: string]: string } = {};
  for (let part of parts) {
    console.log(part);
    const temp = part.split("=");
    myObject[temp[0]] = temp[1];
  }
  return myObject;
};

// type PageRegisterProps = Required<
//   Pick<
//     RouteComponentProps<{ registrationCode: string }>,
//     "navigate" | "path" | "location"
//   >
// >;

// const PageRegister = injectIntl<
//   RouteComponentProps<{ registrationCode: string }>
const PageRegister = injectIntl<any>(({ registrationCode, intl }) => {
  const theme = useTheme<Theme>();
  console.log("code..... ", registrationCode);
  const [userDetails, setUserDetails] = useState<any>();
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [registrationDetails, setRegistrationDetails] = useState<any>();
  const [signup] = useMutation(SIGN_UP);

  const handleSignUp = async (form: any) => {
    await signup({
      variables: {
        name: form.name,
        email: form.email.toLowerCase(),
        surname: form.surname,
        password: form.password,
        role: registerData.role || "Manager",
        workspace: registerData.workspace || undefined,
        invite: registerData.id || undefined,
      },
    });
    setCurrentStep(2);
  };

  let registerData: any = {};
  if (registrationCode) {
    registerData = registrationMapping(registrationCode);
    console.log("111");
    console.log(registerData.id);
  }
  //TODO: ver si registerData existe.
  const { loading, data } = useQuery(PLAYER_QUERY, {
    variables: { id: registerData.id },
  });

  useEffect(() => {
    if (!data || !data.player) {
      return;
    }

    const newState = { ...data.player };
    newState.email = registerData.email;
    setRegistrationDetails(newState);
  }, [data]);

  if (loading) {
    return (
      <UnauthenticatedLayout>
        <LoadingContainer>
          <PersonAddIcon style={{ fontSize: "80px", color: theme.palette.primary.main }} />
          <SuccessMessage>Creating Your Account...</SuccessMessage>
        </LoadingContainer>
      </UnauthenticatedLayout>
    );
  }

  return (
    <UnauthenticatedLayout>
      {currentStep === 1 && (
        <StepInitial
          userDetails={registrationDetails}
          checkValid={
            /* istanbul ignore next */
            userDetails ? true : false
          }
          newUser={registrationDetails ? false : true} //todo: change this on the route /register
          registrationDetails={registerData}
          onGoNext={(values: any) => {
            setUserDetails(values);
            handleSignUp(values);
          }}
        />
      )}
      {currentStep === 2 && (
        <SuccessCard>
          <SuccessIcon>
            <CheckCircleIcon />
          </SuccessIcon>
          <UserAvatar
            style={{ 
              width: 80, 
              height: 80, 
              fontSize: "3rem",
              margin: "0 auto 24px"
            }}
            user={{
              name: userDetails.name,
              surname: userDetails.surname,
            }}
          />
          <SuccessMessage>
            {`${intl.formatMessage(messages.congratulations)} ${userDetails &&
              userDetails.name}!`}
          </SuccessMessage>
          <SuccessSubtext>
            {intl.formatMessage(messages.accountCreated)}
          </SuccessSubtext>
          <StyledActionLink to="/login">
            <Button>Login to Your Account</Button>
          </StyledActionLink>
        </SuccessCard>
      )}
    </UnauthenticatedLayout>
  );
});

export default PageRegister;
